import { z } from 'zod';
export const sendMessageSchema = z.object({
    content: z.string().min(1, 'Message cannot be empty').max(16000, 'Message is too long'),
    parentId: z.string().uuid().optional(),
    encrypted: z.boolean().optional().default(false),
    // Prisma Int column — cap at 2^31-1 so an oversized epoch fails validation
    // at the boundary instead of blowing up the insert.
    keyEpoch: z.number().int().nonnegative().max(2147483647).optional(),
});
export const editMessageSchema = z.object({
    content: z.string().min(1, 'Message cannot be empty').max(16000, 'Message is too long'),
    encrypted: z.boolean().optional().default(false),
    // Prisma Int column — cap at 2^31-1 so an oversized epoch fails validation
    // at the boundary instead of blowing up the insert.
    keyEpoch: z.number().int().nonnegative().max(2147483647).optional(),
});
//# sourceMappingURL=message.schema.js.map